import { combineReducers } from 'redux'
import applicationReducer from './applicationReducer'
import searchReducer from './searchReducer'
import filterReducer from './filterReducer'
import bookmarkReducer from './bookmarkReducer'
import detailsReducer from './detailsReducer'
import apiErrorReducer from './apiErrorReducer'
import compareReducer from './compareReducer'

/**
 * combined reducer
 */
export default combineReducers({
  application: applicationReducer,
  search: searchReducer,
  filter: filterReducer,
  bookmarks: bookmarkReducer,
  detailData: detailsReducer,
  apiError: apiErrorReducer,
  compare: compareReducer,
})
